export default "__VITE_ASSET__C09JgV5X__"